import React, { useEffect, useMemo, useState } from 'react';

import InboundEditForm from '@components/shared/inbounds/InboundEdit';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import { useAdminInboundService } from '@hooks/admin/inbounds/useAdminInboundService';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';

import adminInventoryAttributeDefinitionService from '@services/admin/inventoryAttributeDefinitionService';
import supplierService from '@services/admin/supplierService';

interface InventoryTypeOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface InventoryAttributeDefinition {
  id?: string;
  name: string;
  [key: string]: unknown;
}

const AdminInboundEdit: React.FC = () => {
  const { warehouses, defaultWarehouseId } = useMerchant();
  const { inventoryTypes: contextInventoryTypes, loading } = useMerchantData()!;

  // Admin session 鎖單一 merchant，inventoryTypes 已經是該 merchant 的清單；不需要過濾。
  const inventoryTypes = useMemo<InventoryTypeOption[]>(
    () => (contextInventoryTypes ?? []) as InventoryTypeOption[],
    [contextInventoryTypes]
  );

  const [inventoryAttributeDefinitions, setInventoryAttributeDefinitions] = useState<InventoryAttributeDefinition[]>([]);

  useEffect(() => {
    let cancelled = false;
    adminInventoryAttributeDefinitionService
      .fetchList()
      .then((result: { success?: boolean; data?: InventoryAttributeDefinition[] }) => {
        if (cancelled) return;
        setInventoryAttributeDefinitions(result?.data ?? []);
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        console.error('Failed to fetch inventory attribute definitions', error);
        setInventoryAttributeDefinitions([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <InboundEditForm
      useInboundService={useAdminInboundService}
      useProductService={useAdminProductService}
      supplierService={supplierService}
      role="admin"
      warehouses={warehouses}
      defaultWarehouseId={defaultWarehouseId}
      inventoryTypes={inventoryTypes}
      allInventoryTypes={inventoryTypes}
      inventoryAttributeDefinitions={inventoryAttributeDefinitions}
      merchantDataLoading={Boolean(loading)}
    />
  );
};

export default AdminInboundEdit;
